(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k2tb-mentorship-pricing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function paint(root, btn) {
      var grid = root.querySelector("[data-cal-grid]");
      if (!grid || !btn) return;
      var year = Number(btn.getAttribute("data-year"));
      var month = Number(btn.getAttribute("data-month")) - 1;
      var first = new Date(year, month, 1);
      var delta = (6 - first.getDay() + 7) % 7;
      var firstSat = new Date(year, month, 1 + delta);
      var start = new Date(firstSat);
      var end = new Date(firstSat);
      end.setDate(firstSat.getDate() + 35);
      var sats = {};
      var mail = {};
      for (var week = 0; week < 6; week++) {
        var saturday = new Date(firstSat);
        saturday.setDate(firstSat.getDate() + week * 7);
        sats[saturday.getFullYear() + "-" + saturday.getMonth() + "-" + saturday.getDate()] = 1;
        [1, 3, 5].forEach(function (back) {
          var q = new Date(saturday);
          q.setDate(saturday.getDate() - back);
          if (q.getTime() < firstSat.getTime()) return;
          mail[q.getFullYear() + "-" + q.getMonth() + "-" + q.getDate()] = 1;
        });
      }
      var legend = root.querySelector("[data-legend-mail]");
      var trackBtn = root.querySelector(".k2tb-tab.is-on");
      if (legend) {
        legend.textContent = trackBtn && trackBtn.getAttribute("data-track") === "law"
          ? "Practice questions, sent by email (Mon, Wed, Fri)"
          : "Bar Qs, sent by email (Mon, Wed, Fri)";
      }
      var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      var dow = ["S", "M", "T", "W", "T", "F", "S"];
      var groups = [];
      var current = null;
      for (var cursor = new Date(start); cursor <= end; cursor.setDate(cursor.getDate() + 1)) {
        var keyMonth = cursor.getFullYear() + "-" + cursor.getMonth();
        if (!current || current.key !== keyMonth) {
          current = { key: keyMonth, label: months[cursor.getMonth()] + " " + cursor.getFullYear(), days: [] };
          groups.push(current);
        }
        current.days.push(new Date(cursor.getTime()));
      }
      var html = "";
      groups.forEach(function (group) {
        html += '<section class="k2tb-month"><p class="k2tb-month-name">' + group.label + '</p><div class="k2tb-cal-grid">';
        dow.forEach(function (d) { html += '<span class="k2tb-dow">' + d + "</span>"; });
        var lead = group.days[0].getDay();
        for (var i = 0; i < lead; i++) html += '<span class="k2tb-day is-empty"></span>';
        group.days.forEach(function (day) {
          var key = day.getFullYear() + "-" + day.getMonth() + "-" + day.getDate();
          var cls = "k2tb-day";
          if (sats[key]) cls += " is-sat";
          else if (mail[key]) cls += " is-mail";
          html += '<span class="' + cls + '">' + day.getDate() + "</span>";
        });
        html += "</div></section>";
      });
      grid.innerHTML = html;
    }

    function enc(value) {
      return encodeURIComponent(value == null ? "" : String(value));
    }

    function queryString(pairs) {
      return pairs
        .filter(function (pair) { return pair[1] !== "" && pair[1] != null; })
        .map(function (pair) { return enc(pair[0]) + "=" + enc(pair[1]); })
        .join("&");
    }

    function currentSelection(root) {
      var trackBtn = root.querySelector(".k2tb-tab.is-on");
      var batchBtn = root.querySelector(".k2tb-batch.is-on");
      var law = trackBtn && trackBtn.getAttribute("data-track") === "law";
      return {
        program: law ? "Mentorship Program for Law Students" : "Mentorship Program for Bar Reviewees",
        schedule: batchBtn ? batchBtn.getAttribute("data-title") : "",
        when: batchBtn ? batchBtn.getAttribute("data-when") : ""
      };
    }

    function priceLabel(raw) {
      var digits = String(raw || "").replace(/[^\d]/g, "");
      if (!digits) return "";
      return "₱" + Number(digits).toLocaleString("en-PH");
    }

    function invoiceText(sel, tierName, label, bookDeal) {
      var lines = [
        "Program: " + sel.program,
        "Schedule: " + sel.schedule + (sel.when ? ", " + sel.when : ""),
        "Package: " + tierName,
        "Fee: " + label
      ];
      if (bookDeal) lines.push("Books: " + bookDeal);
      return lines.join("\n");
    }

    function signupHref(root, link) {
      var base = root.getAttribute("data-button-link") || "https://www.keystothebar.com/pages/checkout";
      var sel = currentSelection(root);
      var tierName = link.getAttribute("data-tier-label") || "";
      var packageName = /books|keys to the bar/i.test(tierName) ? "Mentorship and Keys to the Bar Full Set" : "Mentorship";
      var price = (link.getAttribute("data-price") || "").replace(/[^\d]/g, "");
      var bookDeal = link.getAttribute("data-book") || "";
      var label = priceLabel(price);
      var query = queryString([
        ["pleaseSelect", sel.program],
        ["pleaseSelect40", sel.schedule],
        ["pricingTier", packageName],
        ["program", sel.program],
        ["schedule", sel.schedule],
        ["scheduleWhen", sel.when],
        ["tier", packageName],
        ["price", price],
        ["priceLabel", label],
        ["programPrice", (link.getAttribute("data-program-price") || "").replace(/[^\d]/g, "")],
        ["bookPrice", (link.getAttribute("data-book-price") || "").replace(/[^\d]/g, "")],
        ["shipPrice", (link.getAttribute("data-ship-price") || "").replace(/[^\d]/g, "")],
        ["bookDeal", bookDeal],
        ["invoiceText", invoiceText(sel, packageName, label, bookDeal)]
      ]);
      var stub = base.split("?")[0];
      return stub + "?" + query;
    }

    function applyLinks(root) {
      root.querySelectorAll(".k2tb-cta").forEach(function (link) {
        link.setAttribute("href", signupHref(root, link));
      });
    }

    function setTrack(root, track) {
      root.querySelectorAll(".k2tb-tab").forEach(function (tab) {
        var on = tab.getAttribute("data-track") === track;
        tab.classList.toggle("is-on", on);
        tab.setAttribute("aria-selected", on ? "true" : "false");
      });
      root.querySelectorAll("[data-blurb], [data-note], [data-features]").forEach(function (el) {
        var key = el.getAttribute("data-blurb") || el.getAttribute("data-note") || el.getAttribute("data-features");
        el.hidden = key !== track;
      });
      applyLinks(root);
      paint(root, root.querySelector(".k2tb-batch.is-on"));
      equalTiers(root);
    }

    function equalTiers(root) {
      var cards = root.querySelectorAll("[data-tier-card]");
      if (!cards.length) return;
      cards.forEach(function (card) { card.style.minHeight = "0px"; });
      var max = 0;
      cards.forEach(function (card) {
        if (card.offsetHeight > max) max = card.offsetHeight;
      });
      cards.forEach(function (card) { card.style.minHeight = max + "px"; });
    }

    function bind(root) {
      if (root.getAttribute("data-bound") === "1") return;
      root.setAttribute("data-bound", "1");
      var first = root.querySelector(".k2tb-batch.is-on");
      paint(root, first);
      applyLinks(root);
      equalTiers(root);
      window.addEventListener("resize", function () { equalTiers(root); });
      root.querySelectorAll(".k2tb-tab").forEach(function (tab) {
        tab.addEventListener("click", function () {
          setTrack(root, tab.getAttribute("data-track"));
        });
      });
      root.querySelectorAll(".k2tb-batch").forEach(function (btn) {
        btn.addEventListener("click", function () {
          root.querySelectorAll(".k2tb-batch").forEach(function (other) {
            var on = other === btn;
            other.classList.toggle("is-on", on);
            other.setAttribute("aria-checked", on ? "true" : "false");
          });
          paint(root, btn);
          applyLinks(root);
        });
      });

      root.querySelectorAll("[data-tier-card]").forEach(function (card) {
        card.addEventListener("click", function (event) {
          if (event.target.closest(".k2tb-cta")) return;
          root.querySelectorAll("[data-tier-card]").forEach(function (other) {
            other.classList.toggle("is-selected", other === card);
          });
        });
      });
    }

    function boot() {
      document.querySelectorAll(".k2tb").forEach(bind);
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
    else boot();
    document.addEventListener("shopify:section:load", function (event) {
      var root = event.target && event.target.querySelector && event.target.querySelector(".k2tb");
      if (root) bind(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
